import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';

export const ModalOverlay = styled.View`
  flex: 1;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.6);
  padding: ${RFValue(20)}px;
`;

export const ModalContent = styled.View`
  width: 100%;
  max-width: ${RFValue(340)}px;
  background-color: ${({theme}) => theme.colors.background};
  border-radius: ${RFValue(20)}px;
  padding: ${RFValue(24)}px;
  align-items: center;
`;

export const IconWrapper = styled.View`
  width: ${RFValue(56)}px;
  height: ${RFValue(56)}px;
  border-radius: ${RFValue(28)}px;
  background-color: ${({theme}) => theme.colors.alert_blue_bg};
  justify-content: center;
  align-items: center;
  margin-bottom: ${RFValue(16)}px;
`;

export const Icon = styled(MaterialCommunityIcons)`
  font-size: ${RFValue(26)}px;
  color: ${({theme}) => theme.colors.alert_blue_icon};
`;

export const ModalTitle = styled.Text`
  text-align: center;
  font-size: ${RFValue(15)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.semibold};
  margin-bottom: ${RFValue(8)}px;
`;

export const ModalText = styled.Text`
  text-align: center;
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text};
  font-family: ${({theme}) => theme.fonts.regular};
  line-height: ${RFValue(18)}px;
  margin-bottom: ${RFValue(20)}px;
`;

export const ButtonWrapper = styled.View`
  width: 100%;
`;

export const LinkButtonWrapper = styled.View`
  align-items: center;
  margin-top: ${RFValue(14)}px;
`;
